module.exports = __webpack_public_path__ + "static/media/captura-de-pantalla-2012-07-02-a-las-18-43-37.40c259f2.png";